import { useState } from 'react';

/**
 * Hook to manage favorite toggle state with loading and animation
 * @param {Function} onToggle - Callback function when favorite is toggled
 * @returns {Object} - Loading state, animating state, and handler function
 */
export function useFavoriteToggle(onToggle) {
  const [loadingFavorites, setLoadingFavorites] = useState(new Set());
  const [animatingFavorites, setAnimatingFavorites] = useState(new Set());

  const handleToggleFavorite = (uri) => {
    // Trigger loading state
    setLoadingFavorites((prev) => {
      const newSet = new Set(prev);
      newSet.add(uri);
      return newSet;
    });

    // Trigger animation
    setAnimatingFavorites((prev) => {
      const newSet = new Set(prev);
      newSet.add(uri);
      return newSet;
    });

    // Call the parent handler and wait for it to complete
    Promise.resolve(onToggle(uri)).finally(() => {
      // Remove loading state after request completes
      setTimeout(() => {
        setLoadingFavorites((prev) => {
          const newSet = new Set(prev);
          newSet.delete(uri);
          return newSet;
        });
      }, 300);
    });

    // Remove animation class after animation completes
    setTimeout(() => {
      setAnimatingFavorites((prev) => {
        const newSet = new Set(prev);
        newSet.delete(uri);
        return newSet;
      });
    }, 300);
  };

  return {
    loadingFavorites,
    animatingFavorites,
    handleToggleFavorite,
  };
}
